import { render } from "./InfoLabel.vue?vue&type=template&id=4692eedf"
import script from "./InfoLabel.vue?vue&type=script&lang=js"
export * from "./InfoLabel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/rizome.dvit.cloud/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__